import { z } from "zod";

export const validationSchema = z.object({
  projectId: z.string().uuid(),
  teamIds: z.array(z.string().uuid()),
  userId: z.string().uuid(),
});
